import React, { useEffect,  useState } from "react";

import axios from "axios";
import { commonUrl, redirectUrl } from "src/config";
import {  useNavigate } from "react-router";
import dayjs from "dayjs";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

const PrintOneThroughProps = ({state,componentRef,handlePrint}) => {
  // const location = useLocation();
  const navigate = useNavigate();
  const [company, setCompany] = useState(null);
  const [logo, setLogo] = useState(null);
  const { header, table, type } = state || {};

  



  useEffect(() => {
    function getStatusDatas() {
      axios
        .get(commonUrl + "main/getCompanyDetails", { withCredentials: true })
        .then((res) => {
          if (res.data[0]) {
            setCompany(res?.data[0]);
            if (res?.data[0]?.logo) {
              const parseLogo = JSON.parse(res?.data[0]?.logo);
              setLogo(parseLogo?.img);
            }
          }
        })
        .catch((err) => {
          if (err.response?.status === 401 || err.response?.status === 403) {
            window.location.href = redirectUrl;
          }
          alert(err);
        });
    }

    getStatusDatas();
  }, []);

  const totalQty = table.reduce((acc, cuu) => acc + cuu.qty, 0);

  return (
    <div style={{ padding: "12px" }}>
      <div style={{ marginBottom: "10px" }}>
        <Button variant="contained" onClick={handlePrint} autoFocus>Print</Button>
        <Button style={{ marginLeft: "10px" }} onClick={() => navigate(-1)}>Back</Button>
      </div>
      <div
        style={{
          maxWidth: "700px",
          backgroundColor: "white",
          padding: "10px",
          fontFamily: "sans-serif",
        }}
        ref={componentRef}
      >
        <div style={{ textAlign: "center" }}>
          {logo && <img src={logo} width={90} alt="logo" />}
          <h3>{company?.Name}</h3>
          <p>{company?.Add1} {company?.Place}</p>
          <p>{company?.Ph}</p>
          <p>{company?.Web}</p>
          <h3>{type || "INVOICE"}</h3>
        </div>
        <hr />
        <div>
          <p>Inv. No: {header?.billNo}</p>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>Date: {header?.billDate}</p>
            <p>Time: {header?.billTime}</p>
          </div>
        </div>
        <hr />
        <p>Name: {header?.party?.name || header?.party?.label}</p>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{width:'100%'}}>
            <p>Mobile: {header?.party?.phone}</p>
            <p>Plan: {header?.party?.plan_name || ""}</p>
          </div>
          <div style={{width:'100%'}}>
            {type === "QUOTATION" &&<p>Delivery Date: {header?.deliveryDate ? dayjs(header?.deliveryDate).format("DD/MM/YYYY") : ''}</p>}
           {type !== "QUOTATION" && <p>Exp: {header?.party?.plan_end_date ? dayjs(header?.party?.plan_end_date).format("DD/MM/YYYY") : ''}</p>}

            {type !== "QUOTATION" &&<p>Qty Left: {header?.party?.plan_items_left}</p>}
          </div>
        </div>
        <hr />
        <table style={{ width: "100%", textAlign: "center", fontSize: "12px" }}>
          <thead>
            <tr>
              <th style={{ width: "5%" }}>SI</th>
              <th style={{ width: "45%", textAlign: "left" }}>Item</th>
              <th>Varient</th>
              <th style={{ width: "5%" }}>Qty</th>
              <th style={{ width: "20%" }}>Type</th>
              {type !== "QUOTATION" && <th style={{ width: "15%" }}>Discount</th>}
              {type !== "QUOTATION" && <th style={{ width: "15%" }}>Rate</th>}
              {type !== "QUOTATION" && <th style={{ width: "15%" }}>Total</th>}
            </tr>
          </thead>
          <tbody>
            {table?.map((item, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td>{index + 1}</td>
                  <td colSpan={5} style={{ textAlign: "left" }}>{item.item}</td>
                  

                </tr>
                <tr>
                  <td style={{ width: "5%" }}></td>
              <td style={{ width: "45%", textAlign: "left" }}></td>
                  <td style={{ textAlign: "center" }}>{item.note}</td>
                  <td >{item.qty}</td>
                  <td>{item.type}</td>
                  {type !== "QUOTATION" && <td>{item.Dis}</td>}
                  {type !== "QUOTATION" && <td>{item.rate}</td>}
                  {type !== "QUOTATION" && <td>{item.total}</td>}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        <hr />
        {type !== "QUOTATION" ? (
          <div>
            <div style={{ textAlign: "right" }}>
              <p>Subtotal: {header?.total?.toFixed(2)}</p>
              <p>Disc Amount: {header?.discPercAmt?.toFixed(2) || header?.discAmt?.toFixed(2)}</p>
              <p><strong>Net Amount: {header?.netTotal?.toFixed(2)}</strong></p>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "right" }}>
            <p><strong>TOTAL QTY: {totalQty}</strong></p>
          </div>
        )}
        <hr />
        <p style={{ textAlign: "center", fontWeight: "bold" }}>Thank you, Visit again</p>
      </div>
    </div>
  );
};

export default PrintOneThroughProps;
PrintOneThroughProps.propTypes = {
  state: PropTypes.any,
  componentRef: PropTypes.any,
  handlePrint: PropTypes.any

};

